/** @jsxImportSource @emotion/react */

import { ReactComponent as IconsClose } from "assets/mobile/icons/close.svg";
import { useNavigate } from "react-router-dom";

import { HeaderMobileStyle } from "./style.index";

interface Props {
  title: string;
}

const HeaderMobile = ({ title }: Props) => {
  const navigate = useNavigate();
  return (
    <header css={HeaderMobileStyle.wrapper}>
      <div css={HeaderMobileStyle.content}>
        <span>{title}</span>
        <div
          onClick={() => {
            navigate(`/user`);
          }}
          css={HeaderMobileStyle.btn}
        >
          <IconsClose />
        </div>
      </div>
    </header>
  );
};

export default HeaderMobile;
